import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CourseBanner from "../../components/course-detail/CourseBanner";
import CourseContent from "../../components/course-detail/CourseContent";
// import InstituteStudentImportCard from "../../components/institute/InstituteStudentImportCard";
import CourseBuyCard from "../../components/course-detail/CourseBuyCard";
import PageHeader from "../../components/PageHeader";

function InstituteProgramDetail() {
  const [courseData, setCourseData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const { slug } = useParams(); // Get program slug from URL parameters

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        setIsLoading(true);
        setError("");
        const role = sessionStorage.getItem("role");
        const token = process.env.REACT_APP_API_TOKEN;
        const LMS = process.env.REACT_APP_API_LMS;

        if (!slug) {
          throw new Error("Program slug is missing from URL");
        }

        const response = await fetch(`${LMS}/api/get-program?program=${slug}&role=${role}`, {
          method: 'GET',
          headers: {
            'Authorization': token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error! Status: ${response.status} - ${errorText}`);
        }

        const data = await response.json();
        setCourseData(data.data);
        
      } catch (error) {
        console.error("Failed to fetch course details:", error);
        setError(error.message || 'Failed to fetch course details');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCourseDetails();
  }, [slug]);

  console.log("courseData", courseData);
  
  // Transform API data to match component expectations
  const transformedData = courseData ? {
    title: courseData.program_title,
    duration: courseData.duration,
    description: courseData.detail_description,
    banner: courseData.banner,
    totalLessons: courseData.courses?.reduce((total, course) => total + (course.chapters?.length || 0), 0) || 0,
    course: {
      tabs: [
        {
          tab: "About The Course",
          content: {
            description: courseData.description || "",
            learningObjectives: courseData.detail_description?.split('\n')
              .filter(line => line.trim().length > 0)
              .map(line => line.replace(/<[^>]*>/g, '')) || [
              "Course objectives not available"
            ]
          }
        },
        {
          tab: "Lessons",
          content: {
            modules: courseData.courses || []
          }
        },
        {
          tab: "Curated by",
          content: {
            faculty_name: courseData.instructors?.[0] ? 
              `${courseData.instructors[0].first_name} ${courseData.instructors[0].last_name}` : 
              "Expert Instructor",
            faculty_img: courseData.instructors?.[0]?.profile_image || 
              "assets/images/users/avatar-1.jpg",
            description: courseData.instructors?.[0]?.profile_summary || 
              "Experienced instructor with expertise in the field"
          }
        }
      ]
    },
    image: courseData.program_image || courseData.courses?.[0]?.course_banner || "assets/images/small/img-1.jpg",
    preview_video: courseData.preview_video,
    instituteInfo: {
      programTitle: courseData.program_title,
      certificateType: courseData.category?.name || "Certificate Program",
      institute: courseData.association_partners?.[0]?.name || "Hunarho",
      duration: courseData.duration,
      applyBy: "Open Enrollment",
      price: {
        discounted: courseData.discounted_price || "0",
        original: courseData.price !== courseData.discounted_price ? courseData.price : null
      },
      action: courseData.external_url
    }
  } : null;

  const renderErrorState = () => (
    <div className="col-12">
      <div className="card">
        <div className="card-body text-center py-5">
          <img 
            src="/assets/images/error-illustration.svg" 
            alt="Error" 
            className="mb-4" 
            style={{ width: '200px' }} 
          />
          <h4 className="fw-semibold mb-3">Oops! Something went wrong</h4>
          <p className="text-muted fs-15 mb-4">
            {error.includes("404") ? 
              "We couldn't find the course you're looking for." :
              "We're having trouble loading this course right now."}
          </p>
          <div className="d-flex gap-2 justify-content-center">
            <button 
              className="btn btn-soft-primary"
              onClick={() => window.location.reload()}
            >
              <i className="ri-refresh-line align-bottom me-1"></i> Try Again
            </button>
            <a href="/institute-dashboard" className="btn btn-soft-dark">
              <i className="ri-home-4-line align-bottom me-1"></i> Back to Dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="row">
        <div className="col-12">
          <PageHeader title="Course Enrollment" 
            breadcrumbs={[
              { label: "Dashboard", path: "/institute-dashboard" },
              { label: "Course Details", active: true }
            ]}
          />
        </div>
      </div>

      <div className="row mb-4">
        <CourseBanner data={transformedData} />
      </div>

      <div className="row">
        {isLoading ? (
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center py-5">
                <div className="spinner-grow text-primary mb-3" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <h5 className="fw-medium mb-2">Loading Course Details</h5>
                <p className="text-muted mb-0">Please wait while we fetch the course information...</p>
              </div>
            </div>
          </div>
        ) : error ? (
          renderErrorState()
        ) : transformedData ? (
          <>
            <CourseContent courseData={transformedData} />
            <CourseBuyCard courseData={transformedData} />
          </>
        ) : (
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center py-5">
                <i className="ri-file-list-3-line text-muted" style={{ fontSize: '4rem' }}></i>
                <h4 className="mt-3 mb-2">No Course Data Available</h4>
                <p className="text-muted mb-3">The course details you're looking for are not available at the moment.</p>
                <a href="/institute-dashboard" className="btn btn-soft-primary">
                  <i className="ri-arrow-left-line align-bottom me-1"></i> Back to Courses
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default InstituteProgramDetail;